module.exports = __webpack_public_path__ + "img/img1.348acbf6.jpg";